
import XHeader from 'vux/src/components/x-header/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import imgUrl from "@/assets/flag_testerror.png";

export default {
components: {
XHeader,
XImg,
XButton
},
data() {
return {
imgUrl: imgUrl,
myDoneResult: {
finishCount: 0,
errorCount: 0,
finishRate: 0,
totalcount: 0
}
};
},
created() {
this.initSubjectInfo();
},
methods: {
getData(errType) {
this.$router.push({
path: "/ErrorList",
query: {
type: errType
}
});
},
initSubjectInfo() {
if (this.UserInfo != undefined && this.ClassInfo != undefined) {
this.$http({
method: "get",
url: "wxexam.ashx?op=LoadMyDoneResultOfSubject",
params: {
cusId: this.UserInfo.CusId,
courseId: this.ClassInfo.CourseId,
errPeriodType: 0
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
var finishRate = 0;
if (response.data.finishcount > 0) {
finishRate =
(1 - response.data.errorcount / response.data.finishcount) *
100;
}
if (finishRate < 0) {
finishRate = 0;
}

this.myDoneResult = {
finishCount: response.data.finishcount,
errorCount: response.data.errorcount,
finishRate: finishRate,
totalcount: response.data.totalcount
};
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
}
},
computed: {
UserInfo: function() {
return this.$store.getters.getUserInfo;
},
ClassInfo: function() {
return this.$store.getters.getClassInfo;
},
numTop: function() {
var imgHeight = document.body.clientWidth / 1.3327;
var top = 60;
top += imgHeight / 3;
return top + "px";
}
}
};



// WEBPACK FOOTER //
// ./src/components/ErrorInfo.vue